/** GemxQL operation name for the campaign-paths V2 query (also the react-query key namespace). */
export const CAMPAIGN_PATHS_V2_QUERY_NAME = 'CampaignPathsQL';

/** GemxQL field token used to scope the campaign-paths query to a single experiment variant. */
export const CAMPAIGN_PATHS_EXPERIMENT_VARIANT_ID_FIELD = 'experiment_variant_id';
